import { type ReactElement } from "react";
import { Link } from "react-router";

import { isTruthy } from "@vega-core/utils/isTruthy";

type Props = {
  action?: VoidFunction;
  href?: string;
  icon?: ReactElement;
  text: string;
};

const linkClassName =
  "flex cursor-pointer items-center gap-3 p-3 body-base-medium text-text/primary hover:text-text/secondary hover:bg-background/secondary rounded-md";

/**
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use ActionMenu instead.
 */
export function MenuItem({ action, href, icon, text }: Props) {
  if (isTruthy(href)) {
    return (
      <Link
        className={linkClassName}
        onClick={(e) => {
          if (action) {
            e.preventDefault();
            action();
          }
        }}
        to={href}
      >
        {icon ? <span className="flex-shrink-0">{icon}</span> : null}
        <span>{text}</span>
      </Link>
    );
  }

  return (
    <a
      className={linkClassName}
      onClick={(e) => {
        if (action) {
          e.preventDefault();
          action();
        }
      }}
    >
      {icon ? <span className="flex-shrink-0">{icon}</span> : null}
      <span>{text}</span>
    </a>
  );
}
